import { Location } from "@angular/common";
import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { iconsLibrary } from "../../../theme/constants";
import { EButtonType } from "../../data-types/button.enum";
import { ECoworkerView } from "../../data-types/coworker.enums";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { EActiveTab } from "../../data-types/tabs.enum";
import { CoworkerService } from "../../services/coworker.service";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { CoworkerBookingCardComponent } from "../shared/coworker-booking-card/coworker-booking-card.component";
import { UserService } from "../../services/user.service";
import { showAlertAction } from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import * as moment from "moment";
import { StateService } from "../../services/state.service";

declare const window;
@Component({
  selector: "cowing-core-coworker-profile",
  templateUrl: "./coworker-profile.component.html",
  styleUrls: ["./coworker-profile.component.scss"],
})
export class CoworkerProfileComponent implements OnInit {
  public EActiveTab = EActiveTab;
  constructor(
    private _router: Router,
    private localStorageService: LocalStorageService,
    private coworker: CoworkerService,
    private users: UserService,
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  async ngOnInit() {}

  public navigateTo(link) {
    this._router.navigate([`${link}`]);
  }

  public logOut() {
    this.localStorageService.clear();
    return this.navigateTo("login");
  }

  public openPage(url: string) {
    window.open(url, "_blank");
  }

  public requestPwdRecovery() {
    this.coworker
      .getCoworkerInfo(this.localStorageService.get(EStorageType.Coworker))
      .then((info) => {
        this.users
          .requestPwdRecovery(info.email)
          .then(() => {
            this._store.dispatch(
              showAlertAction({
                payload: {
                  message: this.translate.instant("login.success"),
                  title: this.translate.instant("login.done"),
                  type: "alert",
                },
              })
            );
          })
          .catch((error) => {
            this._store.dispatch(
              showAlertAction({
                payload: {
                  message:
                    error.status === 401
                      ? this.translate.instant("general.expired")
                      : error.data.error,
                  title: this.translate.instant("pwd-recovery.caution"),
                  type: "error",
                },
              })
            );
          });
      })
      .catch((error) => {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message:
                error.status === 401
                  ? this.translate.instant("general.expired")
                  : error.data.error,
              title: this.translate.instant("pwd-recovery.caution"),
              type: "error",
            },
          })
        );
      });
  }

  get getLogOutProfileIcon() {
    return `${iconsLibrary.logOutProfileActive}`;
  }
}
